'use strict';

angular.module('adminEmailTemplatesControllers')

.controller('EmailTemplateSideBarController', ['$scope', 'emailTemplates', function ($scope, emailTemplates) {

    $scope.emailTemplates = emailTemplates;
}]);
